import { type ConsentAudience, consentLabel, consentVariant } from "@/lib/supplierConsent";
import "./ConsentBadge.css";

interface ConsentBadgeProps {
  status: string | null | undefined;
  audience: ConsentAudience;
}

const ICONS = {
  warning: "fa-regular fa-hourglass-half",
  success: "fa-solid fa-circle-check",
  danger: "fa-solid fa-circle-xmark",
} as const;

/** Supplier-consent state of a deal (WP1.6). */
const ConsentBadge = ({ status, audience }: ConsentBadgeProps) => {
  const variant = consentVariant(status);
  return (
    <span className={`consent-badge consent-badge--${variant}`}>
      <i className={ICONS[variant]} aria-hidden="true" />
      {consentLabel(status, audience)}
    </span>
  );
};

export default ConsentBadge;
